<template>
  <div id="admin-container" class="wrapper">
    <div class="inner-wrap">
      <div class="table-filter" v-if="1==2">
        <input id="admin-search-grapevines" type="text" v-model="grapevinesQuery" v-on:keyup.enter="doGrapevineSearch" placeholder="Search grapevines" />
        <button id="btnDoSearch" v-on:click="doGrapevineSearch()" class="pure-button">Search</button>
        <button id="btnClearSearch" v-on:click="clearSearch()" class="pure-button">Clear</button>
      </div>
      <HotTable :root="root" ref="grapevinesTable" :settings="hotSettings" :onAfterChange="afterChangeHandler"></HotTable>
    </div>
  </div>
</template>

<script>
  /* global $ */
  import HotTable from 'vue-handsontable-official'
  import firebase from 'firebase'
  import db from '../firebaseInit'
  import Router from '../../router'

  export default {
    data: function () {
      return {
        root: 'grapevines-table',
        userLoggedIn: false,
        userIsAdmin: this.$globals.userRole == 'admin',
        grapevines: [],
        grapevinesQuery: '',
        searchLimit: 200,
        pageLimit: 1500,
        hotSettings: {
          data: this.grapevines,
          rowHeaders: true,
          contextMenu: true,
          stretchH: 'all',
          autoWrapRow: true,
          className: 'htCenter htMiddle',
          columnSorting: true,
          sortIndicator: true,
          observeChanges: false,
          colHeaders: ['Doc ID', 'Name', 'Privacy', 'User ID', 'Grapes'],
          rowHeights: 50,
          colWidths: [180, 250, 90, 130, 200],
          columns: [
            {data: 'docID', readOnly: true},
            {data: 'name'},
            {data: 'privacy'},
            {data: 'userID'},
            {data: 'grapes', renderer: 'html'}
          ]
        }
      }
    },
    name: 'grapevinesAdmin',
    components: {
      HotTable
    },
    created () {
      let vm = this
      firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
          vm.userLoggedIn = true
        } else {
          vm.userLoggedIn = false
        }
      })
      vm.$globals.isAdmin = true
      vm.showLoading()
      vm.getGrapevines()
      /* Set Change Callback */
      vm.hotSettings.afterChange = vm.afterChangeHandler()
    },
    methods: {
      showLoading () {
        $('body').addClass('pace-running')
        $('.pace').addClass('pace-active')
      },
      hideLoading () {
        $('body').removeClass('pace-running')
        $('.pace').removeClass('pace-active')
      },
      afterChangeHandler: function (changes, source) {
        if (arguments[1] !== 'loadData') {
          if (!changes) {
            return
          }
          for (var i = 0, iLen = changes.length; i < iLen; i += 1) {
            if (changes[i][2] !== changes[i][3]) {
              console.log('trying to change')
              let logicalIndex = this.$refs.grapevinesTable.table.runHooks('modifyRow', changes[i][0])
              let changedDocID = this.$refs.grapevinesTable.table.getDataAtCell(changes[i][0], 0)
              let newData = this.$refs.grapevinesTable.table.getSourceDataAtRow(logicalIndex)
              delete newData._highlightResult
              delete newData.docID
              delete newData.id
              console.log(changedDocID)
              console.log(newData)
              if (changedDocID) {
                this.processChange(changedDocID, newData)
              }
            }
          }
        }
      },
      getGrapevines: function () {
        let vm = this
        var grapevinesRef = db.collection('grapevines').orderBy('name', 'desc').limit(vm.pageLimit)
        grapevinesRef.get().then((querySnapshot) => {
          console.log('created query: ' + querySnapshot.docs.length)
          querySnapshot.forEach((doc) => {
            var grapevineData = doc.data()
            grapevineData.docID = doc.id
            grapevineData.grapes = '<a href="#" data-id="' + doc.id + '" data-name="' + grapevineData.name + '" class="grapevines-view-grapes">View grapes</a>'
            this.grapevines.push(grapevineData)
          })
          /* Load Data */
          vm.$refs.grapevinesTable.table.loadData(vm.grapevines)
          setTimeout(function () {
            vm.hideLoading()
          }, 1000)
        })
      },
      processChange (docID, newData) {
        console.log('trying to update grape')
        var grapeRef = db.collection('grapevines').doc(docID)
        const timestamp = firebase.firestore.FieldValue.serverTimestamp()
        newData.updatedTimestamp = timestamp
        grapeRef.update(newData)
        .then(function (docRef) {
          console.log('Document ' + docID + ' successfully updated!')
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error('Error updating document: ', error)
        })
      },
      loadGrapevineGrapes (docID, grapevineName) {
        Router.push({name: 'admin-grapevine', params: {id: docID, name: encodeURIComponent(grapevineName)}})
      }
    },
    mounted () {
      let $vue = this
      $(document).on('click', '.grapevines-view-grapes', function () {
        $vue.loadGrapevineGrapes($(this).data('id'), $(this).data('name'))
        return false
      })
    }
  }
</script>

<style>
  .table-filter {
    padding: 10px 0;
  }
  .table-filter input {
    height: 40px;
    width: 300px;
    padding: 4px 10px;
    box-sizing: border-box;
  }
  .table-filter .pure-button {
    vertical-align: top;
  }
  #grapevines-table {
    width: 100%;
    height: 100vh;
    height: calc(100vh - 120px);
    margin-top: 4px;
    overflow: hidden;
  }
  #grapevines-table th {
    vertical-align: middle;
  }
  #grapevines-table td {
    max-width: 320px;
    min-width: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap !important;
    padding: 0 10px;
  }
  #grapevines-table thead th .relative {
    padding: 4px 8px;
  }
</style>


// WEBPACK FOOTER //
// src/components/admin/grapevinesAdmin.vue